import React from "react";
import "./TextArea.scss"
const TextArea = ({
  customClass,
  name,
  customId,
  cols = "30",
  rows = "5",
  onChange,
  value,
  placeHolder
}) => {
  return (
    <textarea
    className={`TextArea ${customClass}`}
      name={name}
      id={customId}
      cols={cols}
      rows={rows}
      onChange={onChange}
      placeholder={placeHolder}
      value={value}
    >
    </textarea>
  );
};

export default TextArea;
